import React from "react";

const Calendar = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_10724_705)">
        <path
          d="M13.334 4.75H6.66732C4.82637 4.75 3.33398 6.24238 3.33398 8.08333V14.1667C3.33398 16.0076 4.82637 17.5 6.66732 17.5H13.334C15.1749 17.5 16.6673 16.0076 16.6673 14.1667V8.08333C16.6673 6.24238 15.1749 4.75 13.334 4.75Z"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
        <path
          d="M7 2.5V4.75"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13 2.5V4.75"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.75 8.5H3.25"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinejoin="round"
        />
        <path
          d="M6.9082 11.5H7.09156"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.43359 11.5H10.5669"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9082 11.5H13.0916"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.9082 14.5005H8.2582"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7498 14.5005H10.5664"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9082 14.5005H13.0916"
          stroke="#B70569"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_10724_705">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Calendar;
